import Footer from "components/footer/Footer";
import { HeaderComponent } from "components/ui/header/Header";
import * as Constant from "utilities/Constant";
import "./maintenance.scss";

export default function Maintenance() {
  return (
    <>
      <HeaderComponent userName="" showNavLinks={false} />
      <main className="maintenance">
        <div className="maintenance__content">
          <span className="maintenance__badge">{Constant.MAINTENANCE_BADGE}</span>
          <h1 className="maintenance__title">{Constant.MAINTENANCE_TITLE}</h1>
          <p className="maintenance__message">{Constant.MAINTENANCE_MESSAGE}</p>
        </div>
      </main>
      <Footer />
    </>
  );
}